<template>
  <v-card>
    <div class="d-flex align-center justify-space-between">
      <h4>{{ title }}</h4>
      <v-btn color="error" fab small @click="removeBeneficiary">
        <v-icon>delete</v-icon>
      </v-btn>
    </div>

    <div class="my-4 d-flex align-center">
      Name:
      <v-text-field
        v-model="beneficiary.name"
        placeholder="Name"
        class="form-input"
        hide-details
      />
    </div>

    <div class="my-4 d-flex align-center">
      Relationship:
      <v-select
        v-model="beneficiary.relative_id"
        class="form-input"
        :items="relatives"
        placeholder="Relationship"
        item-value="id"
        item-text="body"
        hide-details
      />
    </div>

    <div class="my-4 d-flex align-center">
      Percentage:
      <span class="ml-2">{{ beneficiary.percent }}%</span>

      <v-slider
        v-model="beneficiary.percent"
        class="form-input"
        min="1"
        max="100"
        thumb-label
        hide-details
      />
    </div>

    <div class="my-4 d-flex align-center">
      DOB:
      <v-text-field
        v-model="beneficiary.dob"
        class="form-input"
        v-mask="'##/##/####'"
        placeholder="mm/dd/yyyy"
        hide-details
      />
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'BeneficiaryForm',
  props: {
    beneficiary: Object,
    removeBeneficiary: Function,
    title: {
      type: String,
      default: 'Primary Beneficiary',
    },
  },
  computed: {
    ...mapGetters({
      relatives: 'baseData/relatives',
    }),
  },
};
</script>

<style scoped>
.form-input {
  padding: 0 !important;
  margin: 0 0 0 1em !important;
}

.beneficiary {
  min-height: 270px;
}
</style>
